import React, { useState, useEffect, useMemo, useCallback } from "react";
import { useParams } from "react-router-dom";
import { useCart } from "../contexts/CartContext";

// Modal de confirmation
const ConfirmationModal = ({ show, title, message, children, onCancel, cancelText = "Fermer" }) => {
  if (!show) return null;
  
  return (
    <div className="modal d-block" style={{ backgroundColor: "rgba(0,0,0,0.5)" }}>
      <div className="modal-dialog modal-dialog-centered">
        <div className="modal-content">
          <div className="modal-header">
            <h5 className="modal-title">{title}</h5>
            <button type="button" className="btn-close" onClick={onCancel} aria-label="Fermer"></button>
          </div>
          <div className="modal-body">
            <p>{message}</p>
            {children}
          </div>
          <div className="modal-footer">
            <button type="button" className="btn btn-secondary" onClick={onCancel}>
              {cancelText}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

// Système de toast simplifié
const toast = {
  success: (message) => console.log('✅ Success:', message),
  info: (message) => console.log('ℹ️ Info:', message),
  error: (message) => console.log('❌ Error:', message)
};

// Styles optimisés
const styles = {
  productImage: {
    width: "100%",
    borderRadius: "0.75rem",
    boxShadow: "0 0.5rem 1rem rgba(0, 0, 0, 0.1)",
    transition: "transform 0.3s ease",
    cursor: "pointer",
  },
  productTitle: {
    fontWeight: "700",
    marginBottom: "1rem",
    color: "#333",
  },
  priceTag: {
    fontSize: "1.75rem",
    fontWeight: "700",
    color: "#543ba4",
    marginBottom: "1rem",
  },
  priceBadge: {
    fontSize: "0.75rem",
    fontWeight: "600",
    backgroundColor: "#f89638",
    color: "white",
    padding: "0.25rem 0.5rem",
    borderRadius: "0.375rem",
    marginLeft: "0.5rem",
  },
  categoryTag: {
    backgroundColor: "#f3f0ff",
    color: "#543ba4",
    fontWeight: "500",
    borderRadius: "50rem",
    padding: "0.35rem 0.75rem",
    fontSize: "0.85rem",
    display: "inline-block",
    marginBottom: "1rem",
  },
  stockStatus: {
    fontWeight: "500",
    display: "inline-flex",
    alignItems: "center",
    marginBottom: "1rem",
  },
  stockDot: {
    width: "8px",
    height: "8px",
    borderRadius: "50%",
    marginRight: "6px",
    backgroundColor: "#28a745",
  },
  quantitySelector: {
    width: "130px",
    display: "flex",
    alignItems: "center",
    border: "1px solid #ced4da",
    borderRadius: "0.375rem",
    overflow: "hidden",
  },
  quantityButton: {
    border: "none",
    background: "transparent",
    padding: "0.5rem 0.75rem",
    fontSize: "1rem",
    cursor: "pointer",
    transition: "background-color 0.2s ease",
  },
  quantityInput: {
    border: "none",
    textAlign: "center",
    width: "50px",
    padding: "0.5rem 0",
    fontSize: "1rem",
    outline: "none",
  },
  addToCartBtn: {
    backgroundColor: "#f89638",
    borderColor: "#f89638",
    color: "white",
    fontWeight: "500",
    padding: "0.75rem 1.5rem",
    marginLeft: "1rem",
    transition: "all 0.2s ease",
    border: "none",
    borderRadius: "0.375rem",
    cursor: "pointer",
  },
  wishlistBtn: {
    backgroundColor: "transparent",
    border: "1px solid #ced4da",
    borderRadius: "0.375rem",
    padding: "0.75rem",
    marginLeft: "0.5rem",
    transition: "all 0.2s ease",
    cursor: "pointer",
  },
  sectionTitle: {
    fontSize: "1.25rem",
    fontWeight: "600",
    marginBottom: "1rem",
    position: "relative",
    paddingBottom: "0.5rem",
  },
  sectionTitleLine: {
    position: "absolute",
    left: "0",
    bottom: "0",
    width: "50px",
    height: "3px",
    backgroundColor: "#543ba4",
    borderRadius: "2px",
  },
  tabBtn: {
    border: "none",
    background: "transparent",
    padding: "0.75rem 1.25rem",
    borderBottom: "2px solid transparent",
    fontWeight: "500",
    color: "#666666",
    transition: "all 0.2s ease",
    cursor: "pointer",
  },
  tabBtnActive: {
    borderBottomColor: "#543ba4",
    color: "#543ba4",
  },
  reviewAvatar: {
    width: "50px",
    height: "50px",
    borderRadius: "50%",
    backgroundColor: "#543ba4",
    color: "white",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    fontSize: "1.25rem",
    fontWeight: "bold",
  },
  progressContainer: {
    height: "8px",
    backgroundColor: "#e9ecef",
    borderRadius: "4px",
    width: "100%",
  },
  progressBar: {
    height: "100%",
    borderRadius: "4px",
    backgroundColor: "#543ba4",
    transition: "width 0.3s ease",
  },
  featureIcon: {
    fontSize: "1.5rem",
    color: "#543ba4",
    marginBottom: "0.5rem",
  },
  featureTitle: {
    fontSize: "0.95rem",
    fontWeight: "600",
    color: "#333",
    marginBottom: "0.25rem",
  },
  featureDescription: {
    fontSize: "0.85rem",
    color: "#666",
  },
  purchaseOptionBtn: {
    border: "1px solid #dee2e6",
    borderRadius: "0.375rem",
    padding: "0.75rem 1rem",
    backgroundColor: "white",
    cursor: "pointer",
    transition: "all 0.2s ease",
    width: "100%",
    textAlign: "left",
    marginBottom: "1rem",
  },
  purchaseOptionBtnActive: {
    borderColor: "#543ba4",
    backgroundColor: "#f3f0ff",
    boxShadow: "0 0 0 0.2rem rgba(84, 59, 164, 0.25)",
  },
  relatedTitle: {
    fontSize: "1.5rem",
    fontWeight: "600",
    marginBottom: "2rem",
    textAlign: "center",
    position: "relative",
  },
  relatedTitleLine: {
    width: "60px", 
    height: "3px", 
    backgroundColor: "#543ba4", 
    margin: "0.75rem auto",
    borderRadius: "2px",
  },
};

const ProductDetail = () => {
  const { id } = useParams();
  const { getProductById, products, addItem } = useCart();
  
  // États du composant
  const [product, setProduct] = useState(null);
  const [loading, setLoading] = useState(true);
  const [quantity, setQuantity] = useState(1);
  const [activeTab, setActiveTab] = useState("description");
  const [isFavorite, setIsFavorite] = useState(false);
  const [showShareModal, setShowShareModal] = useState(false);
  const [purchaseOption, setPurchaseOption] = useState("single");
  const [selectedImageIndex, setSelectedImageIndex] = useState(0);
  const [frequency, setFrequency] = useState("monthly");

  // Produits similaires mémorisés
  const relatedProducts = useMemo(() => {
    if (!product) return [];
    return products.filter(
      (p) => p.id !== product.id && p.category === product.category
    ).slice(0, 3);
  }, [product, products]);

  // Images du produit (simulation de galerie)
  const productImages = useMemo(() => {
    if (!product) return [];
    return [
      product.image,
      product.image + "?v=2", 
      product.image + "?v=3", 
      product.image + "?v=4"
    ];
  }, [product]);

  // Prix calculé selon l'option
  const finalPrice = useMemo(() => {
    if (!product) return 0;
    if (purchaseOption === "subscription") {
      return product.price * 0.85; // -15%
    }
    return product.price;
  }, [product, purchaseOption]);

  // Chargement du produit
  useEffect(() => {
    if (id) {
      const foundProduct = getProductById(parseInt(id));
      setProduct(foundProduct);
      setLoading(false);
    }
  }, [id, getProductById]);

  // Gestionnaires d'événements optimisés avec useCallback
  const decrementQuantity = useCallback(() => {
    setQuantity(prev => Math.max(1, prev - 1));
  }, []);

  const incrementQuantity = useCallback(() => {
    setQuantity(prev => prev + 1);
  }, []);

  const handleQuantityChange = useCallback((e) => {
    const value = parseInt(e.target.value);
    if (!isNaN(value) && value > 0) {
      setQuantity(value);
    }
  }, []);

  const handleAddToCart = useCallback(() => {
    if (product) {
      // Utiliser la fonction addItem du contexte
      const isSubscription = purchaseOption === "subscription";
      
      for (let i = 0; i < quantity; i++) {
        addItem(product, isSubscription);
      }
      
      toast.success(`${product.name} ajouté au panier`);
    }
  }, [product, quantity, addItem, purchaseOption]);

  const toggleFavorite = useCallback(() => {
    setIsFavorite(prev => {
      const newValue = !prev;
      toast[newValue ? 'success' : 'info'](
        `${product?.name} ${newValue ? 'ajouté à' : 'retiré de'} vos favoris`
      );
      return newValue;
    });
  }, [product]);

  const handleShare = useCallback((platform) => {
    const shareData = {
      title: product.name,
      text: product.description,
      url: window.location.href
    };

    console.log(`Partage ${platform}:`, shareData);
    toast.success(`Produit partagé sur ${platform}`);
    setShowShareModal(false);
  }, [product]);

  const handleTabChange = useCallback((tab) => {
    setActiveTab(tab);
  }, []);

  const handleImageSelect = useCallback((index) => {
    setSelectedImageIndex(index);
  }, []);

  // Gestion des états de chargement et d'erreur
  if (loading) {
    return (
      <div className="container py-5 text-center">
        <div className="spinner-border" style={{ color: "#543ba4" }} role="status">
          <span className="visually-hidden">Chargement...</span>
        </div>
        <p className="mt-3">Chargement du produit...</p>
      </div>
    );
  }

  if (!product) {
    return (
      <div className="container py-5 text-center">
        <div className="mb-4">
          <i className="bi bi-exclamation-circle display-1 text-muted" aria-hidden="true"></i>
        </div>
        <h2>Produit non trouvé</h2>
        <p className="text-muted mb-4">
          Le produit que vous recherchez n'existe pas ou a été retiré.
        </p>
        <a href="/category" className="btn btn-primary">
          Voir nos autres produits
        </a>
      </div>
    );
  }

  return (
    <div className="product-detail-page">
      {/* Détails du produit */}
      <section className="py-5">
        <div className="container">
          <div className="row g-4">
            {/* Galerie d'images */}
            <div className="col-lg-5">
              <img
                src={productImages[selectedImageIndex]}
                alt={product.name}
                className="img-fluid"
                style={styles.productImage}
                onMouseEnter={(e) => {
                  e.target.style.transform = "scale(1.05)";
                }}
                onMouseLeave={(e) => {
                  e.target.style.transform = "scale(1)";
                }}
              />

              {/* Miniatures */}
              <div className="row mt-3 g-2">
                {productImages.map((image, index) => (
                  <div key={index} className="col-3">
                    <img
                      src={image}
                      alt={`${product.name} vue ${index + 1}`}
                      className={`img-fluid img-thumbnail ${
                        selectedImageIndex === index ? 'border-primary border-2' : ''
                      }`}
                      style={{ 
                        cursor: "pointer",
                        transition: "all 0.2s ease",
                        opacity: selectedImageIndex === index ? 1 : 0.7
                      }}
                      onClick={() => handleImageSelect(index)}
                      onMouseEnter={(e) => {
                        e.target.style.opacity = "1";
                      }}
                      onMouseLeave={(e) => {
                        e.target.style.opacity = selectedImageIndex === index ? "1" : "0.7";
                      }}
                    />
                  </div>
                ))}
              </div>
            </div>

            {/* Informations produit */}
            <div className="col-lg-7">
              <span style={styles.categoryTag}>{product.category}</span>
              <h1 style={styles.productTitle}>{product.name}</h1>

              {/* Note produit */}
              {product.rating && (
                <div className="mb-3">
                  <div className="d-flex align-items-center">
                    <div className="text-warning me-2">
                      {Array.from({ length: 5 }, (_, i) => (
                        <i key={i} className={`bi ${i < product.rating ? 'bi-star-fill' : 'bi-star'}`}></i>
                      ))}
                    </div>
                    <span className="text-muted">
                      ({product.rating.toFixed(1)}) • {product.reviewCount || 12} avis
                    </span>
                  </div>
                </div>
              )}

              {/* Prix */}
              <div style={styles.priceTag}>
                {finalPrice.toFixed(2)} €
                {purchaseOption === "subscription" && (
                  <span style={styles.priceBadge}>-15%</span>
                )}
                {purchaseOption === "subscription" && (
                  <div className="small text-muted mt-1">
                    Prix unitaire : <s>{product.price.toFixed(2)} €</s>
                  </div>
                )}
              </div>

              {/* État du stock */}
              <div style={styles.stockStatus}>
                <span style={styles.stockDot}></span>
                {product.inStock ? "En stock - Expédition sous 24h" : "Rupture de stock"}
              </div>

              {/* Description courte */}
              <p className="mb-4">{product.description}</p>

              {/* Options d'achat */}
              {product.hasSubscriptionOption && (
                <div className="mb-4">
                  <button
                    style={{
                      ...styles.purchaseOptionBtn,
                      ...(purchaseOption === "single" ? styles.purchaseOptionBtnActive : {}),
                    }}
                    onClick={() => setPurchaseOption("single")}
                    className="d-flex justify-content-between align-items-center"
                  >
                    <div>
                      <div className="fw-bold mb-1">Achat unique</div>
                      <div className="small text-muted">Commande ponctuelle, livraison unique</div>
                    </div>
                    <div className="form-check">
                      <input
                        className="form-check-input"
                        type="radio"
                        checked={purchaseOption === "single"}
                        onChange={() => setPurchaseOption("single")}
                        id="singlePurchase"
                      />
                    </div>
                  </button>

                  <button
                    style={{
                      ...styles.purchaseOptionBtn,
                      ...(purchaseOption === "subscription" ? styles.purchaseOptionBtnActive : {}),
                    }}
                    onClick={() => setPurchaseOption("subscription")}
                    className="d-flex justify-content-between align-items-center"
                  >
                    <div>
                      <div className="d-flex align-items-center fw-bold mb-1">
                        <span>Abonnement</span>
                        <span className="ms-2 badge bg-warning text-dark">-15%</span>
                      </div>
                      <div className="small text-muted">Recevez régulièrement, économisez 15%</div>
                    </div>
                    <div className="form-check">
                      <input
                        className="form-check-input"
                        type="radio"
                        checked={purchaseOption === "subscription"}
                        onChange={() => setPurchaseOption("subscription")}
                        id="subscriptionPurchase"
                      />
                    </div>
                  </button>

                  {purchaseOption === "subscription" && (
                    <div className="mb-4 p-3 border rounded bg-light">
                      <div className="mb-3">
                        <label htmlFor="frequency" className="form-label fw-bold">
                          Fréquence de livraison
                        </label>
                        <select 
                          className="form-select" 
                          id="frequency"
                          value={frequency}
                          onChange={(e) => setFrequency(e.target.value)}
                        >
                          <option value="monthly">Mensuelle</option>
                          <option value="bimonthly">Tous les 2 mois</option>
                          <option value="quarterly">Trimestrielle</option>
                        </select>
                        <div className="form-text">
                          <i className="bi bi-info-circle me-1"></i>
                          Modifiable ou résiliable à tout moment
                        </div>
                      </div>
                    </div>
                  )}
                </div>
              )}

              {/* Actions */}
              <div className="d-flex align-items-center mb-4 flex-wrap gap-2">
                <div style={styles.quantitySelector}>
                  <button
                    style={styles.quantityButton}
                    onClick={decrementQuantity}
                    disabled={quantity <= 1}
                    onMouseEnter={(e) => {
                      if (!e.target.disabled) e.target.style.backgroundColor = "#f8f9fa";
                    }}
                    onMouseLeave={(e) => {
                      e.target.style.backgroundColor = "transparent";
                    }}
                    aria-label="Diminuer la quantité"
                  >
                    <i className="bi bi-dash"></i>
                  </button>
                  <input
                    type="text"
                    style={styles.quantityInput}
                    value={quantity}
                    onChange={handleQuantityChange}
                    aria-label="Quantité"
                  />
                  <button
                    style={styles.quantityButton}
                    onClick={incrementQuantity}
                    onMouseEnter={(e) => {
                      e.target.style.backgroundColor = "#f8f9fa";
                    }}
                    onMouseLeave={(e) => {
                      e.target.style.backgroundColor = "transparent";
                    }}
                    aria-label="Augmenter la quantité"
                  >
                    <i className="bi bi-plus"></i>
                  </button>
                </div>
                
                <button
                  style={styles.addToCartBtn}
                  onClick={handleAddToCart}
                  disabled={!product.inStock}
                  onMouseEnter={(e) => {
                    if (!e.target.disabled) {
                      e.target.style.backgroundColor = "#e67e22";
                      e.target.style.transform = "translateY(-1px)";
                    }
                  }}
                  onMouseLeave={(e) => {
                    e.target.style.backgroundColor = "#f89638";
                    e.target.style.transform = "translateY(0)";
                  }}
                >
                  <i className="bi bi-cart-plus me-2"></i>
                  {product.inStock ? "Ajouter au panier" : "Rupture de stock"}
                </button>
                
                <button
                  style={styles.wishlistBtn}
                  onClick={toggleFavorite}
                  className={isFavorite ? "text-danger" : "text-muted"}
                  onMouseEnter={(e) => {
                    e.target.style.borderColor = "#543ba4";
                  }}
                  onMouseLeave={(e) => {
                    e.target.style.borderColor = "#ced4da";
                  }}
                  aria-label={isFavorite ? "Retirer des favoris" : "Ajouter aux favoris"}
                >
                  <i className={`bi ${isFavorite ? "bi-heart-fill" : "bi-heart"}`}></i>
                </button>
                
                <button 
                  style={styles.wishlistBtn} 
                  onClick={() => setShowShareModal(true)}
                  onMouseEnter={(e) => {
                    e.target.style.borderColor = "#543ba4";
                  }}
                  onMouseLeave={(e) => {
                    e.target.style.borderColor = "#ced4da";
                  }}
                  aria-label="Partager ce produit"
                >
                  <i className="bi bi-share"></i>
                </button>
              </div>

              {/* Caractéristiques produit */}
              <div className="row gy-3 mb-4">
                <div className="col-md-6">
                  <div className="d-flex align-items-center">
                    <i className="bi bi-truck me-2" style={styles.featureIcon}></i>
                    <div>
                      <div style={styles.featureTitle}>Livraison gratuite</div>
                      <div style={styles.featureDescription}>Dès 50€ d'achat</div>
                    </div>
                  </div>
                </div>
                <div className="col-md-6">
                  <div className="d-flex align-items-center">
                    <i className="bi bi-arrow-repeat me-2" style={styles.featureIcon}></i>
                    <div>
                      <div style={styles.featureTitle}>Retours gratuits</div>
                      <div style={styles.featureDescription}>Sous 30 jours</div>
                    </div>
                  </div>
                </div>
                <div className="col-md-6">
                  <div className="d-flex align-items-center">
                    <i className="bi bi-shield-check me-2" style={styles.featureIcon}></i>
                    <div>
                      <div style={styles.featureTitle}>Paiement sécurisé</div>
                      <div style={styles.featureDescription}>CB, PayPal, Apple Pay</div>
                    </div>
                  </div>
                </div>
                <div className="col-md-6">
                  <div className="d-flex align-items-center">
                    <i className="bi bi-gift me-2" style={styles.featureIcon}></i>
                    <div>
                      <div style={styles.featureTitle}>Cadeau offert</div>
                      <div style={styles.featureDescription}>À partir de 75€</div>
                    </div>
                  </div>
                </div>
              </div>

              {/* Code promo */}
              <div className="alert alert-light border mb-0">
                <div className="d-flex align-items-center">
                  <i className="bi bi-tag-fill me-2" style={{ color: "#f89638", fontSize: "1.25rem" }}></i>
                  <div>
                    <strong>-10% sur votre première commande</strong>
                    <br />
                    <span className="small">
                      Code promo : <span className="fw-bold text-primary">BIENVENUE</span>
                    </span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Informations détaillées avec onglets */}
      <section className="py-4 bg-light">
        <div className="container">
          <div className="card border-0 shadow-sm">
            <div className="card-header bg-white py-3 border-bottom-0">
              <ul className="nav nav-tabs-alt border-0">
                {[
                  { id: "description", label: "Description" },
                  { id: "specifications", label: "Détails" },
                  { id: "reviews", label: `Avis (${product.reviewCount || 12})` },
                  { id: "shipping", label: "Livraison" }
                ].map(tab => (
                  <li key={tab.id} className="nav-item">
                    <button
                      style={{
                        ...styles.tabBtn,
                        ...(activeTab === tab.id ? styles.tabBtnActive : {}),
                      }}
                      onClick={() => handleTabChange(tab.id)}
                      aria-selected={activeTab === tab.id}
                    >
                      {tab.label}
                    </button>
                  </li>
                ))}
              </ul>
            </div>
            <div className="card-body p-4">
              {activeTab === "description" && (
                <div>
                  <h4 style={styles.sectionTitle}>
                    À propos de cette box
                    <span style={styles.sectionTitleLine}></span>
                  </h4>
                  <p>{product.description}</p>
                  <p>
                    Notre équipe d'experts sélectionne méticuleusement chaque produit pour garantir une expérience exceptionnelle. 
                    Que vous soyez à la recherche de nouvelles découvertes ou que vous souhaitiez vous faire plaisir, 
                    notre box est conçue pour répondre à vos attentes.
                  </p>

                  <h5 className="mt-4 mb-3">Ce que vous recevrez :</h5>
                  <ul className="list-unstyled">
                    {[
                      "4-6 produits soigneusement sélectionnés",
                      "Un guide détaillé sur chaque produit", 
                      "Des conseils d'utilisation exclusifs",
                      "Un emballage éco-responsable",
                      "Accès à des offres spéciales sur notre boutique en ligne"
                    ].map((item, index) => (
                      <li key={index} className="mb-2">
                        <i className="bi bi-check-circle-fill me-2 text-success"></i>
                        {item}
                      </li>
                    ))}
                  </ul>
                </div>
              )}

              {activeTab === "specifications" && (
                <div>
                  <h4 style={styles.sectionTitle}>
                    Caractéristiques
                    <span style={styles.sectionTitleLine}></span>
                  </h4>
                  <div className="table-responsive">
                    <table className="table table-striped">
                      <tbody>
                        <tr>
                          <th style={{ width: "30%" }}>Nombre de produits</th>
                          <td>4-6 produits par box</td>
                        </tr>
                        <tr>
                          <th>Valeur minimale</th>
                          <td>Valeur totale minimale de 50€</td>
                        </tr>
                        <tr>
                          <th>Dimensions</th>
                          <td>30 x 20 x 10 cm</td>
                        </tr>
                        <tr>
                          <th>Poids</th>
                          <td>500g - 1kg selon le contenu</td>
                        </tr>
                        <tr>
                          <th>Options d'achat</th>
                          <td>Achat unique ou abonnement sans engagement</td>
                        </tr>
                        <tr>
                          <th>Origine</th>
                          <td>Produits européens, priorité aux producteurs locaux</td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
              )}

              {activeTab === "reviews" && (
                <div>
                  <h4 style={styles.sectionTitle}>
                    Avis clients
                    <span style={styles.sectionTitleLine}></span>
                  </h4>

                  <div className="row mb-4">
                    <div className="col-md-4 mb-4 mb-md-0">
                      <div className="text-center">
                        <div className="display-4 fw-bold mb-2" style={{ color: "#543ba4" }}>
                          {product.rating?.toFixed(1) || "4.8"}
                        </div>
                        <div className="mb-2">
                          {Array.from({ length: 5 }, (_, i) => (
                            <i key={i} className={`bi ${i < (product.rating || 4.8) ? 'bi-star-fill' : 'bi-star-half'} text-warning`}></i>
                          ))}
                        </div>
                        <p className="text-muted">{product.reviewCount || 12} avis clients</p>
                      </div>
                    </div>

                    <div className="col-md-8">
                      {[
                        {
                          initials: "ML",
                          name: "Marie L.",
                          date: "Il y a 2 semaines",
                          rating: 5,
                          title: "Une box incroyable !",
                          comment: "Je suis ravie de ma box ! Tous les produits sont de qualité supérieure."
                        },
                        {
                          initials: "PT", 
                          name: "Pierre T.",
                          date: "Il y a 1 mois",
                          rating: 4,
                          title: "Très bon rapport qualité-prix",
                          comment: "C'est ma troisième box et je suis toujours aussi satisfait."
                        }
                      ].map((review, index) => (
                        <div key={index} className="mb-4 pb-4 border-bottom">
                          <div className="d-flex mb-3">
                            <div style={styles.reviewAvatar}>{review.initials}</div>
                            <div className="ms-3">
                              <h6 className="mb-0">{review.name}</h6>
                              <div className="text-muted small">{review.date}</div>
                              <div className="mt-1">
                                {Array.from({ length: 5 }, (_, i) => (
                                  <i key={i} className={`bi ${i < review.rating ? 'bi-star-fill' : 'bi-star'} text-warning`}></i>
                                ))}
                              </div>
                            </div>
                          </div>
                          <h6 className="mb-2">{review.title}</h6>
                          <p className="mb-0">{review.comment}</p>
                        </div>
                      ))}
                    </div>
                  </div>
                </div>
              )}

              {activeTab === "shipping" && (
                <div>
                  <h4 style={styles.sectionTitle}>
                    Livraison et retours
                    <span style={styles.sectionTitleLine}></span>
                  </h4>

                  <div className="mb-4">
                    <h5 className="mb-3">Options de livraison</h5>
                    <div className="table-responsive">
                      <table className="table table-striped">
                        <thead>
                          <tr>
                            <th>Méthode</th>
                            <th>Délai</th>
                            <th>Tarif</th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr>
                            <td>Livraison standard (Belgique)</td>
                            <td>2-3 jours ouvrés</td>
                            <td>4,99 € (Gratuit dès 50 €)</td>
                          </tr>
                          <tr>
                            <td>Livraison express (Belgique)</td>
                            <td>1 jour ouvré</td>
                            <td>9,99 €</td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                  </div>

                  <div>
                    <h5 className="mb-3">Politique de retour</h5>
                    <p>
                      Nous acceptons les retours dans les 30 jours suivant la réception de votre commande. 
                      Pour être éligibles au retour, les articles doivent être inutilisés et dans leur emballage d'origine.
                    </p>
                  </div>
                </div>
              )}
            </div>
          </div>
        </div>
      </section>

      {/* Produits similaires */}
      {relatedProducts.length > 0 && (
        <section className="py-5">
          <div className="container">
            <h3 style={styles.relatedTitle}>
              Vous aimerez aussi
              <div style={styles.relatedTitleLine}></div>
            </h3>

            <div className="row g-4">
              {relatedProducts.map((relatedProduct) => (
                <div key={relatedProduct.id} className="col-md-6 col-lg-4">
                  <a 
                    href={`/product/${relatedProduct.id}`}
                    className="text-decoration-none text-reset d-block"
                    style={{ transition: "transform 0.2s ease" }}
                    onMouseEnter={(e) => {
                      e.currentTarget.style.transform = "translateY(-2px)";
                    }}
                    onMouseLeave={(e) => {
                      e.currentTarget.style.transform = "translateY(0)";
                    }}
                  >
                    <div className="card h-100 shadow-sm">
                      <img 
                        src={relatedProduct.image} 
                        className="card-img-top" 
                        alt={relatedProduct.name}
                        style={{ height: "200px", objectFit: "cover" }}
                        loading="lazy"
                      />
                      <div className="card-body d-flex flex-column">
                        <h5 className="card-title">{relatedProduct.name}</h5>
                        <p className="card-text text-muted flex-grow-1">{relatedProduct.description}</p>
                        <div className="mt-auto">
                          <div className="d-flex justify-content-between align-items-center">
                            <span className="h5 mb-0 text-primary">{relatedProduct.price.toFixed(2)}€</span>
                            {relatedProduct.rating && (
                              <div className="text-warning">
                                {Array.from({ length: 5 }, (_, i) => (
                                  <i key={i} className={`bi ${i < relatedProduct.rating ? 'bi-star-fill' : 'bi-star'}`}></i>
                                ))}
                              </div>
                            )}
                          </div>
                        </div>
                      </div>
                    </div>
                  </a>
                </div>
              ))}
            </div>
          </div>
        </section>
      )}

      {/* Modal de partage */}
      <ConfirmationModal
        show={showShareModal}
        title="Partager ce produit"
        message="Choisissez une plateforme pour partager ce produit :"
        onCancel={() => setShowShareModal(false)}
      >
        <div className="d-flex justify-content-center gap-3 my-3">
          {[
            { platform: "Facebook", icon: "bi-facebook", color: "primary" },
            { platform: "Twitter", icon: "bi-twitter-x", color: "info" },
            { platform: "WhatsApp", icon: "bi-whatsapp", color: "success" },
            { platform: "Email", icon: "bi-envelope", color: "danger" }
          ].map(({ platform, icon, color }) => (
            <button
              key={platform}
              className={`btn btn-outline-${color} rounded-circle p-3`}
              onClick={() => handleShare(platform)}
              style={{ width: "60px", height: "60px" }}
              aria-label={`Partager sur ${platform}`}
            >
              <i className={`bi ${icon} fs-4`}></i>
            </button>
          ))}
        </div>
        <div className="text-center mt-3">
          <small className="text-muted">
            Partagez ce produit avec vos amis et votre famille
          </small>
        </div>
      </ConfirmationModal>
    </div>
  );
};

export default ProductDetail;